import { FC } from 'react'
import { today } from '../constants/adminCalendar'

interface MiniFooterProps {}

const MiniFooter: FC<MiniFooterProps> = ({}) => {
  const year = today.getFullYear()

  return (
    <footer className='border-t border-gray-200 py-12 text-center md:flex md:justify-between px-12 sm:px-6'>
      <div className='flex flex-col'>
        <p className='text-base text-gray-400'>&copy; {year} Praxis am Bulkamp, alle Rechte vorbehalten.</p>
        <div className='flex gap-4 justify-center text-gray-400 text-sm mt-2'>
          <p>Impressum</p> | <p>Datenschutz</p>
        </div>
      </div>
      <div className='mt-6 flex justify-center space-x-8 md:mt-0'></div>
    </footer>
  )
}

export default MiniFooter
